// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-tab[data-v-2d345a1a] {\n  overflow: auto;\n}\n.theme--light.info-tab[data-v-2d345a1a] {\n  background-color: #f6f6f6;\n}\n.theme--dark.info-tab[data-v-2d345a1a] {\n  background-color: #273039;\n}", ""]);
// Exports
module.exports = exports;
